import $ from 'jquery';
import clusterImage from "../../images/buyMap/cluster.svg";
import clusterRedImage from "../../images/buyMap/cluster-red.svg";
import mapMarkerImage from "../../images/buyMap/map-marker.png";


$(function () {
    // Google maps.
    const $mapsContainer = $('#buyApartmentMap');
    const initMap = () => {
        console.log("init map!!");
        const finalClusterImage = clusterImage;
        const map = new google.maps.Map($mapsContainer[0], {
            center: new google.maps.LatLng(parseFloat($mapsContainer.data("center-lat")), parseFloat($mapsContainer.data("center-lng"))),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            zoomControl: true,
            zoomControlOptions: {position: google.maps.ControlPosition.LEFT_TOP},
            styles: [{featureType: "poi", stylers: [{visibility: "off"}]}],
            disableDefaultUI: !0,
            zoom: 17
        });

        const markers = JSON.parse($mapsContainer.attr('data-apartments'))
            .map(data => {

                const info = `<div class="info-window">
                    <div class="info-window__close">&#10005;</div>
                    <a href="${data.link}"><div class="info-window__image" style="background-image: url(${data.thumbnailUrl})"></div></a>
                    <div class="info-window__lower-section c-grey0"><p class="info-window__street-name font-sm font-md circularstd-bold c-black">${data.title}</p>
                    <p class="info-window__district-name font-xs circularstd-book c-grey">${data.district_name}</p>
                    <h5 class="info-window__prize font-sm circularstd-book c-black m-0">
                      ${data.symbol}   ${data.price}
                    </h5>
                        <div class="d-flex flex-wrap font-12 circularstd-book c-black">
                            ${data.approx_sqm}   sqm &nbsp;
                            ${data.bedrooms} bedroom &nbsp;&nbsp;
                            ${data.bathrooms}  bath &nbsp;
                        </div>
                        <div class="text-center">
                             <div class="marker__triangle"></div>
                        </div>
                    </div>`;
                const infoWindow = new google.maps.InfoWindow({
                    content: info,
                    maxWidth: 380,
                    pixelOffset: new google.maps.Size(10, 30)
                });

                const marker = new google.maps.Marker({
                    icon: `${mapMarkerImage}`,
                    position: {
                        lat: parseFloat(data.lat),
                        lng: parseFloat(data.lng)
                    },
                    infoWindow: infoWindow,

                });

                google.maps.event.addListener(marker, 'click', function () {
                    markers.forEach(marker => marker.infoWindow.close());
                    marker.infoWindow.open(map, marker);
                });
                marker.infoWindow.open(map, marker);
                return marker;

            });

        const markerCluster = new MarkerClusterer(
            map,
            markers, {
                imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
                styles: [{
                    url: `${finalClusterImage}`,
                    height: 40,
                    width: 40,
                    textColor: "#ffffff",
                    textSize: 16,
                    fontFamily: "circularstd_book",
                    fontWeight: "normal"
                }, {
                    url: `${finalClusterImage}`,
                    height: 60,
                    width: 60,
                    textColor: "#ffffff",
                    textSize: 16,
                    fontFamily: "circularstd_book",
                    fontWeight: "normal"
                }, {
                    url: `${finalClusterImage}`,
                    height: 90,
                    width: 90,
                    textColor: "#ffffff",
                    textSize: 16,
                    fontFamily: "circularstd_book",
                    fontWeight: "normal"
                }, {
                    url: `${finalClusterImage}`,
                    height: 120,
                    width: 120,
                    textColor: "#ffffff",
                    textSize: 16,
                    fontFamily: "circularstd_book",
                    fontWeight: "normal"
                }, {
                    url: `${finalClusterImage}`,
                    height: 150,
                    width: 150,
                    textColor: "#ffffff",
                    textSize: 16,
                    fontFamily: "circularstd_book",
                    fontWeight: "normal"
                }]
            });
    };

    initMap();
});


